import { axiosInstance } from './index';
import { AutocompleteResult } from '../interfaces';

const getAutocompleteResults = async (
  query: string,
): Promise<AutocompleteResult[]> => {
  const response = await axiosInstance.get(`/autocomplete`, {
    params: { query },
  });

  return response.data.results;
};

export const autocomplete = {
  getAutocompleteResults,
};
